module.exports = __webpack_public_path__ + "img/tpc-web-8.6000e178.jpg";